/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Service_Type_Neuro_Rehab_TermsInputs */

const en_service_type_neuro_rehab_terms = /** @type {(inputs: Service_Type_Neuro_Rehab_TermsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`neuro, stroke, multiple sclerosis, parkinson, pnf, bobath`)
};

const pl_service_type_neuro_rehab_terms = /** @type {(inputs: Service_Type_Neuro_Rehab_TermsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`neurologia, udar, stwardnienie rozsiane, parkinson, porażenie, pnf, bobath`)
};

/**
* | output |
* | --- |
* | "neuro, stroke, multiple sclerosis, parkinson, pnf, bobath" |
*
* @param {Service_Type_Neuro_Rehab_TermsInputs} inputs
* @param {{ locale?: "en" | "pl" }} options
* @returns {LocalizedString}
*/
export const service_type_neuro_rehab_terms = /** @type {((inputs?: Service_Type_Neuro_Rehab_TermsInputs, options?: { locale?: "en" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Service_Type_Neuro_Rehab_TermsInputs, { locale?: "en" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pl") return pl_service_type_neuro_rehab_terms(inputs)
	return en_service_type_neuro_rehab_terms(inputs)
});